"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AkamaiImageSizesJson = _interopRequireDefault(require("./AkamaiImageSizes.json.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SIZE_NUMBERS = Object.keys(_AkamaiImageSizesJson.default).map(function (size) {
  return parseInt(size);
});
var POLICY = 'f';
/**
 * This class is used for Image utility function.s
 */

var ImageUtility = /*#__PURE__*/function () {
  function ImageUtility() {
    _classCallCheck(this, ImageUtility);
  }

  _createClass(ImageUtility, null, [{
    key: "getAkamaiQueryString",

    /**
     * Returns an Akamai query string based on size.
     *
     * @param {number} size Size of the image.
     * @returns {string} Query string.
     */
    value: function getAkamaiQueryString(size) {
      return "?".concat(POLICY, "=").concat(this._getAkamaiSize(size));
    }
    /**
     * Get Akamai formatted size.
     *
     * @param {number} size Image size.
     * @returns {string} Size.
     */

  }, {
    key: "_getAkamaiSize",
    value: function _getAkamaiSize(size) {
      var _iterator = _createForOfIteratorHelper(SIZE_NUMBERS),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var akamaiSize = _step.value;

          if (size <= akamaiSize) {
            return _AkamaiImageSizesJson.default[akamaiSize.toString()];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return _AkamaiImageSizesJson.default[SIZE_NUMBERS[SIZE_NUMBERS.length - 1].toString()];
    }
  }]);

  return ImageUtility;
}();

exports.default = ImageUtility;